import { useRef, useState } from 'react';

import Button from 'components/field/Button';
import Collapse from 'components/global/Collapse';
import Icon from 'components/global/Icon';
import Typography from 'components/global/Typography';

import { faAngleRight } from '@fortawesome/pro-solid-svg-icons';

import * as S from '../Table.styled';
import TableHeaderFilter from './TableHeaderFilter';

const TableFilterMenuItem = ({ column, isFiltered }) => {
	const buttonRef = useRef(null);

	const [active, setActive] = useState(false);
	return (
		<S.MobileFilterMenuItem>
			<Button
				ref={buttonRef}
				onClick={() => setActive(!active)}
				variant="borderless"
				css={S.FilterMenuItemButtonCss}
				fullWidth>
				<S.FilterMenuItemButtonContent>
					{isFiltered && <S.MobileColumnDot />}
					<Typography fontWeight="500">{column.id}</Typography>
				</S.FilterMenuItemButtonContent>
				<Icon className="expandIcon" icon={faAngleRight} />
			</Button>
			<Collapse buttonRef={buttonRef}>
				<S.MobileFilterWrapper>
					<TableHeaderFilter column={column} />
				</S.MobileFilterWrapper>
			</Collapse>
		</S.MobileFilterMenuItem>
	);
};

export default TableFilterMenuItem;
